import React from 'react';

import Notification from '@Components/notification';

import { FormProps } from './form.definition';

export const Form = (props: FormProps) => {
	const {
		children,
		className,
		hasError,
		errorMessage = 'Påkrævede felter er ikke udfyldt eller har fejl',
		handleSubmit
	} = props;

	return (
		<form
			className={ [
				'Form',
				className
			].join(' ') }
			onSubmit={ (e) => handleSubmit(e) }
			noValidate // browser validation turned off
		>
			{ children }
			{ hasError && (
				<Notification isError message={ errorMessage } />
			) }
		</form>
	);
};

export default Form;